import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { startLoading, stopLoading } from "../loading";
import {
  getCall,
  deleteCall,
  getById
} from "../../utils/api";


const initialState = {
  data: [],
  contactData: null,
  error: "",
  status: "idle",
};

export const getContact = createAsyncThunk("contact/get", async (_, { dispatch }) => {
  dispatch(startLoading());
  try {
    const response = await getCall("/admin/v1/all_contact", false);
    return await response?.data;
  } catch (error) {
    return Promise?.reject(error)
  } finally {
    dispatch(stopLoading());
  }
});

export const getContactById = createAsyncThunk(
  "contact/getById",
  async (id, { dispatch }) => {
    dispatch(startLoading());
    try {
      const response = await getById("/admin/v1/show_contact", id, false);
      return await response;
    } catch (error) {
      return Promise?.reject(error)
    } finally {
      dispatch(stopLoading());
    }
  }
);

export const deleteContact = createAsyncThunk(
  "contact/delete",
  async (id, { dispatch }) => {
    dispatch(startLoading());
    try {
      await deleteCall(`/admin/v1/delete_contact/${id}`);
      return await id;
    } catch (error) {
      return Promise?.reject(error)
    } finally {
      dispatch(stopLoading());
    }
  }
);

const contactSlice = createSlice({
  name: "contact",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getContact.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getContact.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(getContact.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      .addCase(getContactById.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getContactById.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.contactData = action.payload;
      })
      .addCase(getContactById.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      .addCase(deleteContact.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = state.data.filter((contact) => contact.id !== action.payload);
      });
  },
});

export default contactSlice.reducer;
